import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createStore, combineReducers, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import WebView from '@medscape-promo/medscapetv/web-view';
import WebViewReducers from '@medscape-promo/medscapetv/web-view/web-view.reducers';
import WebViewMiddleware from '@medscape-promo/medscapetv/web-view/web-view.middleware';
import MainRouter from './main-router';
import * as MainActions from './main.actions';
import MainReducers from './main.reducers';
import MainMiddleware from './main.middleware';
import MainRouterMiddleware from './main-router/main-router.middleware';

import PlaylistReducers from './playlist/playlist.reducers';
import PlaylistMiddleware from './playlist/playlist.middleware';
import PlayerMiddleware from './player/player.middleware';
import PersistentVideoBarReducers from './persistent-video-bar/persistent-video-bar.reducers';
import PersistentVideoBarMiddleware from './persistent-video-bar/persistent-video-bar.middleware';
import CommentsDrawerReducers from './drawers/comments/comments-drawer.reducers';
import CommentsDrawerMiddleware from './drawers/comments/comments-drawer.middleware';
import CommentsDrawer from './drawers/comments';
import TranscriptsDrawerReducers from './drawers/transcripts/transcripts-drawer.reducers';
import TranscriptsDrawerMiddleware from './drawers/transcripts/transcripts-drawer.middleware';
import TranscriptsDrawer from './drawers/transcripts';
import AdsHandlerMiddleware from '@medscape-promo/medscapetv/ads/ads-handler.middleware';

export default class Main extends Component {
    constructor(props) {
        super(props);
        const middlewares = [ 
        	WebViewMiddleware, 
            MainMiddleware,
        	MainRouterMiddleware, 
        	PlaylistMiddleware, 
        	PlayerMiddleware,
        	PersistentVideoBarMiddleware, 
        	CommentsDrawerMiddleware,
            TranscriptsDrawerMiddleware,
            AdsHandlerMiddleware
        ];
        const middlewareEnhancers = applyMiddleware.apply(null,middlewares);
        const reducers = combineReducers({
            WebView: WebViewReducers,
            Main: MainReducers,
            Playlist: PlaylistReducers,
            PersistentVideoBar: PersistentVideoBarReducers,
            CommentsDrawer: CommentsDrawerReducers,
            TranscriptsDrawer: TranscriptsDrawerReducers
        });


        this.store = createStore(reducers, middlewareEnhancers);
        this.store.dispatch(MainActions.init(props.series.path, props.episodes, props.ifiPath));
        //console.log("[Main] props:", props);
    }
    componentDidMount() {
        this.props.onReady(this.store);
    }
    render() {
        const { props } = this;

        return (
            <section className="mtv-app">
		        <Provider store={this.store}>
		        	<WebView medscape={props.medscape} tracking={props.tracking}>
                        <div key="app-container" className="app-container">
			        	    <MainRouter key="main" series={props.series} />
                        </div>
		                <CommentsDrawer key="comments-drawer"/>
		                <TranscriptsDrawer key="transcripts-drawer" />
	                </WebView>
		        </Provider>
	        </section>
        )
    }
    static get propTypes() {
        return {
            medscape: PropTypes.object.isRequired,
            tracking: PropTypes.object.isRequired,
            series: PropTypes.object.isRequired,
            episodes: PropTypes.array.isRequired,
            onReady: PropTypes.func,
            ifiPath: PropTypes.string
        }
    }

    static get defaultProps() {
        return {
            onReady: () => {},
            ifiPath: ""
        }
    }
}